export default {
    "scalars": [
        2,
        3,
        4,
        5,
        6,
        7,
        18,
        21,
        35,
        37,
        39,
        40,
        41,
        90,
        102,
        105,
        107,
        108,
        124,
        125,
        127,
        128,
        131,
        132,
        133,
        148,
        149,
        151,
        157,
        162,
        164,
        183,
        184,
        185,
        188,
        189,
        198,
        264,
        268
    ],
    "types": {
        "CommonError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "ErrorInterface": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "on_CommonError": [
                0
            ],
            "on_RateError": [
                8
            ],
            "on_OtpError": [
                9
            ],
            "on_AccessError": [
                10
            ],
            "on_FormError": [
                11
            ],
            "on_ExternalServiceError": [
                12
            ],
            "on_ProtocolError": [
                13
            ],
            "on_InternalError": [
                14
            ],
            "on_UserError": [
                15
            ],
            "on_VorderError": [
                20
            ],
            "__typename": [
                4
            ]
        },
        "ErrorTypeEnum": {},
        "ErrorNameEnum": {},
        "String": {},
        "Boolean": {},
        "Int": {},
        "Json": {},
        "RateError": {
            "ttl": [
                6
            ],
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "OtpError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "AccessError": {
            "authRedirect": [
                5
            ],
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "FormError": {
            "fieldName": [
                4
            ],
            "fieldLabel": [
                4
            ],
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "ExternalServiceError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "ProtocolError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "InternalError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "UserError": {
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "BasketRuleBenefitDiscount": {
            "UID": [
                4
            ],
            "TYPE": [
                18
            ],
            "DISCOUNT_PERCENT": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "BasketRuleBenefitInterface": {
            "UID": [
                4
            ],
            "TYPE": [
                18
            ],
            "on_BasketRuleBenefitDiscount": [
                16
            ],
            "on_BasketRuleBenefitGift": [
                19
            ],
            "__typename": [
                4
            ]
        },
        "BasketRuleBenefitTypeEnum": {},
        "BasketRuleBenefitGift": {
            "UID": [
                4
            ],
            "TYPE": [
                18
            ],
            "PRODUCT_ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "VorderError": {
            "itemUuid": [
                4
            ],
            "fieldName": [
                4
            ],
            "fieldLabel": [
                4
            ],
            "section": [
                21
            ],
            "type": [
                2
            ],
            "name": [
                3
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "alertShow": [
                5
            ],
            "alertMessage": [
                4
            ],
            "alertDuration": [
                6
            ],
            "targetShow": [
                5
            ],
            "targetMessage": [
                4
            ],
            "debug": [
                7
            ],
            "rel": [
                7
            ],
            "data": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "VOrderSectionEnum": {},
        "Query": {
            "testPublicpublic": [
                23,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "testOptionalAuthlist": [
                23,
                {
                    "filter": [
                        24
                    ]
                }
            ],
            "testRequiredAuthauthorized": [
                23,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "testAdminOnlyadminOnly": [
                23,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "testCombinedadminOnly": [
                23,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "testCombinedlist": [
                23,
                {
                    "filter": [
                        24
                    ]
                }
            ],
            "hook_query": [
                5
            ],
            "entity_options": [
                26,
                {
                    "entityType": [
                        25
                    ],
                    "ids": [
                        4,
                        "[String!]!"
                    ],
                    "limit": [
                        6
                    ]
                }
            ],
            "entity_type_list": [
                27,
                {
                    "filter": [
                        25
                    ]
                }
            ],
            "entity_type": [
                27,
                {
                    "filter": [
                        25
                    ]
                }
            ],
            "entity_provider_types": [
                28
            ],
            "entity_computed_fields": [
                29
            ],
            "menu_menus": [
                31
            ],
            "list": [
                36
            ],
            "notice_pub_list": [
                38
            ],
            "user_session": [
                42
            ],
            "user_fetch": [
                43,
                {
                    "sessionWrite": [
                        5
                    ]
                }
            ],
            "user_app_client": [
                48
            ],
            "page_single": [
                54,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "page_list": [
                54,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "page_recordset": [
                65,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "page_route": [
                54,
                {
                    "URL": [
                        4
                    ]
                }
            ],
            "company_office_single": [
                68,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        67
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "company_office_list": [
                68,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        67
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "company_office_recordset": [
                72,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        67
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "company_vacancy_single": [
                73,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "company_vacancy_list": [
                73,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "company_vacancy_recordset": [
                75,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "faq_element_single": [
                76,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "faq_element_list": [
                76,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "faq_element_recordset": [
                77,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "geo_geocoder_locations_by_coords": [
                78,
                {
                    "lat": [
                        39
                    ],
                    "lon": [
                        39
                    ]
                }
            ],
            "geo_geocoder_location_by_address": [
                78,
                {
                    "address": [
                        4
                    ]
                }
            ],
            "search_suggestions_popular": [
                79
            ],
            "search_suggestions": [
                79,
                {
                    "query": [
                        4
                    ]
                }
            ],
            "offer_single": [
                81,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "offer_list": [
                81,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "offer_recordset": [
                86,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "offer_user_list": [
                81
            ],
            "offer_common_list": [
                81
            ],
            "push_vapid_public_key": [
                4
            ],
            "push_user_subscribers": [
                87
            ],
            "fortune_prizes": [
                88
            ],
            "fortune_user_prize": [
                92
            ],
            "telegram_single": [
                94,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        93
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "telegram_list": [
                94,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        93
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "telegram_recordset": [
                95,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        93
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "telegram_chat_by_id": [
                94,
                {
                    "chatId": [
                        4,
                        "String!"
                    ]
                }
            ],
            "telegram_active_chats": [
                94,
                {
                    "limit": [
                        6
                    ]
                }
            ],
            "camera_element_list": [
                96,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "review_list": [
                98,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_single": [
                109,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        135
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "catalog_product_list": [
                109,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        135
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_recordset": [
                136,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        135
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_all": [
                109,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        135
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_fav_list": [
                109,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        135
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_fav_list2": [
                109,
                {
                    "type": [
                        4
                    ]
                }
            ],
            "catalog_product_search": [
                137,
                {
                    "query": [
                        4
                    ],
                    "elementDetail": [
                        5
                    ]
                }
            ],
            "catalog_product_search_new": [
                109,
                {
                    "query": [
                        4
                    ],
                    "filterSuggestion": [
                        138
                    ],
                    "elementDetail": [
                        5
                    ]
                }
            ],
            "sale_order_active_list": [
                100,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        139
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_order_ensure_payment": [
                118,
                {
                    "id": [
                        6
                    ],
                    "hash": [
                        4
                    ],
                    "paymentId": [
                        6
                    ]
                }
            ],
            "vorder_current": [
                140,
                {
                    "check": [
                        5
                    ]
                }
            ],
            "vorder_summary": [
                168
            ],
            "vorder_basket_products": [
                109
            ],
            "sale_profile_single": [
                144,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "sale_profile_list": [
                144,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_profile_recordset": [
                169,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_client_card_single": [
                172,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        170
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "sale_client_card_list": [
                172,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        170
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_client_card_recordset": [
                175,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        170
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_client_card_fetch": [
                172,
                {
                    "isScope": [
                        5
                    ],
                    "refetch": [
                        5
                    ]
                }
            ],
            "sale_client_card_apply_by_phone": [
                172,
                {
                    "phone": [
                        4
                    ]
                }
            ],
            "sale_delivery_zones": [
                176
            ],
            "sale_order_statuses": [
                117
            ],
            "basket_rule_list": [
                160,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "sale_bonus_level_list": [
                173,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "product_ingredient_list": [
                178,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "product_modificator_list": [
                180
            ],
            "product_flag_list": [
                191,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "order_restriction_list": [
                193,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "catalog_product_section_list": [
                196,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        195
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "order_history": [
                100,
                {
                    "limit": [
                        6
                    ]
                }
            ],
            "client_segment_single": [
                199,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "client_segment_list": [
                199,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "client_segment_recordset": [
                200,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "feature_single": [
                201,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "feature_list": [
                201,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "feature_recordset": [
                204,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "feature_list_for_user": [
                201,
                {
                    "user_id": [
                        6
                    ]
                }
            ],
            "call_tracking_phone": [
                205
            ],
            "yandex_metric_goal_single": [
                207,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ]
                }
            ],
            "yandex_metric_goal_list": [
                207,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "yandex_metric_goal_recordset": [
                208,
                {
                    "id": [
                        6
                    ],
                    "where": [
                        7
                    ],
                    "filter": [
                        50
                    ],
                    "nav": [
                        53
                    ],
                    "computed": [
                        63,
                        "[EntityComputedFieldInput!]"
                    ],
                    "nocache": [
                        5
                    ]
                }
            ],
            "__typename": [
                4
            ]
        },
        "TestItem": {
            "id": [
                6
            ],
            "name": [
                4
            ],
            "description": [
                4
            ],
            "createdAt": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "TestItemFilterInput": {
            "id": [
                6
            ],
            "name": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "EntityQueryTargetInput": {
            "UID": [
                4
            ],
            "PROVIDER_TYPE": [
                4
            ],
            "PROVIDER": [
                4
            ],
            "BUNDLE_CODE": [
                6
            ],
            "BUNDLE_ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "EntityOption": {
            "UID": [
                4
            ],
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "TAXONOMY_TERM_ID": [
                6
            ],
            "TAXONOMY_TERM_IDS": [
                6
            ],
            "PARENT_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "EntityType": {
            "UID": [
                4
            ],
            "PROVIDER_TYPE": [
                4
            ],
            "PROVIDER_TYPE_NAME": [
                4
            ],
            "PROVIDER": [
                4
            ],
            "PROVIDER_NAME": [
                4
            ],
            "BUNDLE_CODE": [
                4
            ],
            "BUNDLE_ID": [
                6
            ],
            "ENTITY_TYPE": [
                4
            ],
            "TAXONOMY_TYPE": [
                4
            ],
            "TAXONOMY_MEMBER_TYPE": [
                4
            ],
            "NAME": [
                4
            ],
            "ROLE": [
                4
            ],
            "CLASS": [
                4
            ],
            "RIGHTS": [
                4
            ],
            "TAXONOMY_TERMS": [
                26
            ],
            "OPTIONS": [
                26
            ],
            "__typename": [
                4
            ]
        },
        "EntityProviderType": {
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "EntityComputedField": {
            "entityType": [
                4
            ],
            "entityBundleCode": [
                4
            ],
            "entityBundleId": [
                6
            ],
            "name": [
                4
            ],
            "type": [
                4
            ],
            "conditionDate": [
                5
            ],
            "valueType": [
                4
            ],
            "round": [
                5
            ],
            "valueOptions": [
                30
            ],
            "entityField": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "EntityComputedFieldValueOption": {
            "label": [
                4
            ],
            "value": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "Menu": {
            "id": [
                4
            ],
            "code": [
                4
            ],
            "children": [
                32
            ],
            "__typename": [
                4
            ]
        },
        "MenuItem": {
            "id": [
                4
            ],
            "parent": [
                4
            ],
            "label": [
                4
            ],
            "infoLabel": [
                4
            ],
            "command": [
                33
            ],
            "url": [
                4
            ],
            "blank": [
                5
            ],
            "native": [
                5
            ],
            "icon": [
                4
            ],
            "imageId": [
                6
            ],
            "image": [
                34
            ],
            "display": [
                4
            ],
            "color": [
                4
            ],
            "bgColor": [
                4
            ],
            "children": [
                32
            ],
            "roles": [
                4
            ],
            "entityType": [
                4
            ],
            "entityId": [
                4
            ],
            "badge": [
                7
            ],
            "params": [
                7
            ],
            "size": [
                4
            ],
            "outline": [
                5
            ],
            "flat": [
                5
            ],
            "width": [
                4
            ],
            "class": [
                4
            ],
            "onClick": [
                7
            ],
            "dense": [
                5
            ],
            "loading": [
                5
            ],
            "loadingLabel": [
                4
            ],
            "disable": [
                5
            ],
            "textColor": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Command": {
            "code": [
                4
            ],
            "type": [
                4
            ],
            "path": [
                4
            ],
            "params": [
                7
            ],
            "confirm": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "Image": {
            "ID": [
                35
            ],
            "SRC": [
                4
            ],
            "SRC_DEFAULT": [
                4
            ],
            "FILE_SIZE": [
                4
            ],
            "ORIGINAL_NAME": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ID": {},
        "ClientEmit": {
            "id": [
                6
            ],
            "title": [
                4
            ],
            "message": [
                4
            ],
            "body": [
                4
            ],
            "eventName": [
                4
            ],
            "eventData": [
                7
            ],
            "eventGroup": [
                4
            ],
            "targetUserId": [
                6
            ],
            "targetClientId": [
                4
            ],
            "createdAt": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "cls": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "DateFormatEnum": {},
        "ClientNotice": {
            "ID": [
                6
            ],
            "TITLE": [
                4
            ],
            "MESSAGE": [
                4
            ],
            "BODY": [
                4
            ],
            "EVENT_NAME": [
                4
            ],
            "EVENT_DATA": [
                7
            ],
            "EVENT_GROUP": [
                4
            ],
            "ENTITY_TYPE": [
                4
            ],
            "ENTITY_ID": [
                6
            ],
            "TARGET_CLIENT_ID": [
                4
            ],
            "TARGET_USER_ID": [
                39
            ],
            "CREATED_AT_FORMATTED": [
                4
            ],
            "CREATED_AT": [
                6
            ],
            "ACTION_MOBILE": [
                4
            ],
            "ACTIVE": [
                5
            ],
            "IMAGE": [
                34
            ],
            "TARGET": [
                40
            ],
            "BODY_HTML": [
                4
            ],
            "SHOW_AS": [
                41
            ],
            "image": [
                34
            ],
            "IMPORTANT": [
                5
            ],
            "haveBody": [
                5
            ],
            "showAs": [
                4
            ],
            "targetCode": [
                4
            ],
            "actionItems": [
                32
            ],
            "cls": [
                4
            ],
            "isReaded": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "Float": {},
        "NoticeTargetEnum": {},
        "NoticeShowAsEnum": {},
        "UserSession": {
            "SESSION_ID": [
                4
            ],
            "USER_ID": [
                6
            ],
            "FUSER_ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "User": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "SESSION_ID": [
                4
            ],
            "GROUPS": [
                44
            ],
            "ROLES": [
                4
            ],
            "DL": [
                6
            ],
            "LOGIN": [
                4
            ],
            "LOGIN_FORMAT": [
                4
            ],
            "EMAIL": [
                4
            ],
            "NAME_FULL": [
                4
            ],
            "NAME_TEASER": [
                4
            ],
            "LAST_NAME": [
                4
            ],
            "SECOND_NAME": [
                4
            ],
            "PHONE": [
                4
            ],
            "PHONE_FORMATTED": [
                4
            ],
            "PERSONAL_PHOTO": [
                34
            ],
            "PERSONAL_BIRTHDAY": [
                4
            ],
            "DATE_REGISTER": [
                4
            ],
            "LAST_LOGIN": [
                4
            ],
            "PERSON_TYPE_ID": [
                6
            ],
            "PROPS": [
                45
            ],
            "PROMOCODE": [
                4
            ],
            "AVATAR": [
                46
            ],
            "GREETING_NAME": [
                4
            ],
            "FAMILY": [
                47
            ],
            "PROFILE_FILLED": [
                5
            ],
            "PROFILE_GIFT_USED": [
                5
            ],
            "COMPUTED": [
                7
            ],
            "ORDER_COUNT": [
                7
            ],
            "SUBSCRIPTIONS": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "UserGroup": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "DL": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "EntityProp": {
            "ID": [
                6
            ],
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "TYPE": [
                4
            ],
            "VAL": [
                7
            ],
            "VAL_ID": [
                7
            ],
            "VAL_ENUM_ID": [
                7
            ],
            "DESC": [
                7
            ],
            "MUL": [
                5
            ],
            "FILE": [
                34
            ],
            "FILES": [
                34
            ],
            "__typename": [
                4
            ]
        },
        "UserAvatar": {
            "ELEMENT_ID": [
                6
            ],
            "IMAGE": [
                34
            ],
            "__typename": [
                4
            ]
        },
        "UserFamily": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "RELATION": [
                4
            ],
            "USER_ID": [
                4
            ],
            "BIRTHDAY": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "AppClient": {
            "ID": [
                6
            ],
            "CLIENT_ID": [
                4
            ],
            "TOKEN": [
                4
            ],
            "SESSION_ID": [
                4
            ],
            "CURRENT_SESSION_ID": [
                4
            ],
            "USER_ID": [
                6
            ],
            "WEB_PUSH_TOKEN": [
                4
            ],
            "MOBILE_PUSH_TOKEN": [
                4
            ],
            "WEB_PUSH_ENDPOINT": [
                4
            ],
            "WEB_PUSH_P256DH": [
                4
            ],
            "WEB_PUSH_AUTH": [
                4
            ],
            "WEB_PUSH_ACTIVE": [
                5
            ],
            "DEBUG_PARAMS": [
                49
            ],
            "__typename": [
                4
            ]
        },
        "AppClientDebugParams": {
            "eventsTransport": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "ElementListFilterInput": {
            "ID": [
                51
            ],
            "NAME": [
                52
            ],
            "CODE": [
                52
            ],
            "SORT": [
                51
            ],
            "IBLOCK_ID": [
                51
            ],
            "IBLOCK_CODE": [
                52
            ],
            "IBLOCK_SECTION_ID": [
                51
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_DATE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "IntFilterInput": {
            "exists": [
                5
            ],
            "eq": [
                6
            ],
            "in": [
                6
            ],
            "not": [
                6
            ],
            "gt": [
                6
            ],
            "lt": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "StringFilterInput": {
            "exists": [
                5
            ],
            "eq": [
                4
            ],
            "in": [
                4
            ],
            "not": [
                4
            ],
            "like": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "QueryNavInput": {
            "limit": [
                6
            ],
            "page": [
                6
            ],
            "sort": [
                4
            ],
            "sortField": [
                4
            ],
            "asc": [
                5
            ],
            "sortAscending": [
                5
            ],
            "postSort": [
                4
            ],
            "postSortAsc": [
                5
            ],
            "postLimit": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "Page": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                57
            ],
            "DATA_CHUNKS": [
                61
            ],
            "CONTENT_CHUNKS": [
                62
            ],
            "__typename": [
                4
            ]
        },
        "Section": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_TYPE_ID": [
                4
            ],
            "IBLOCK_EXTERNAL_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE": [
                5
            ],
            "PICTURE": [
                34
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DESCRIPTION": [
                4
            ],
            "DESCRIPTION_TYPE": [
                4
            ],
            "LEFT_MARGIN": [
                6
            ],
            "RIGHT_MARGIN": [
                6
            ],
            "DEPTH_LEVEL": [
                6
            ],
            "SEARCHABLE_CONTENT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "SECTION_PAGE_URL": [
                4
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "PARENT": [
                55
            ],
            "PARENTS": [
                55
            ],
            "ELEMENT_CNT": [
                6
            ],
            "META": [
                56
            ],
            "REPLACE_LINK": [
                4
            ],
            "CHILDREN": [
                55
            ],
            "__typename": [
                4
            ]
        },
        "ElementMeta": {
            "TITLE": [
                4
            ],
            "KEYWORDS": [
                4
            ],
            "DESCRIPTION": [
                4
            ],
            "PAGE_TITLE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "PageProps": {
            "TPL_PAGE_VIEW": [
                4
            ],
            "TPL_PAGE_CONTENT": [
                4
            ],
            "DATA_CHUNKS": [
                58
            ],
            "CHUNKS": [
                59
            ],
            "CHUNK_NAME": [
                4
            ],
            "CHUNK_VALUE": [
                60
            ],
            "CHUNK_CODE": [
                4
            ],
            "CHUNK_GROUP": [
                4
            ],
            "META_TITLE": [
                4
            ],
            "META_DESCRIPTION": [
                4
            ],
            "META_KEYWORDS": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ElementPropValueWithDesc": {
            "VALUE": [
                4
            ],
            "DESC": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "PagePropsChunks": {
            "CHUNK_CODE": [
                4
            ],
            "CHUNK_NAME": [
                4
            ],
            "CHUNK_VALUE": [
                60
            ],
            "CHUNK_GROUP": [
                4
            ],
            "UID": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ElementPropValueHtml": {
            "TEXT": [
                4
            ],
            "TYPE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "PageDataChunk": {
            "CODE": [
                4
            ],
            "TYPE": [
                4
            ],
            "VALUE": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "PageContentChunk": {
            "GROUP": [
                4
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "VALUE": [
                4
            ],
            "TYPE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "EntityComputedFieldInput": {
            "id": [
                4
            ],
            "code": [
                4
            ],
            "type": [
                4
            ],
            "filter": [
                64
            ],
            "__typename": [
                4
            ]
        },
        "EntityComputedFieldFilterInput": {
            "value": [
                7
            ],
            "valueFrom": [
                7
            ],
            "valueTo": [
                7
            ],
            "valueIn": [
                7
            ],
            "dateFrom": [
                4
            ],
            "dateFromValue": [
                4
            ],
            "dateTo": [
                4
            ],
            "dateToValue": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "PageRecordset": {
            "info": [
                66
            ],
            "nodes": [
                54
            ],
            "__typename": [
                4
            ]
        },
        "QueryInfo": {
            "total": [
                6
            ],
            "page": [
                6
            ],
            "pages": [
                6
            ],
            "limit": [
                6
            ],
            "nextPage": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "OfficeFilterInput": {
            "ID": [
                51
            ],
            "NAME": [
                52
            ],
            "CODE": [
                52
            ],
            "SORT": [
                51
            ],
            "IBLOCK_ID": [
                51
            ],
            "IBLOCK_CODE": [
                52
            ],
            "IBLOCK_SECTION_ID": [
                51
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_DATE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "CompanyOffice": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                69
            ],
            "__typename": [
                4
            ]
        },
        "CompanyOfficeProps": {
            "MAIN": [
                4
            ],
            "ADDRESS": [
                4
            ],
            "PHONES": [
                4
            ],
            "EMAIL": [
                4
            ],
            "COORDINATES": [
                70
            ],
            "REQUISITES": [
                60
            ],
            "ROLES": [
                71
            ],
            "WORKTIME": [
                4
            ],
            "SERVICE_ID": [
                4
            ],
            "PAYSYSTEM_ID": [
                39
            ],
            "GIS_URL": [
                4
            ],
            "INFO_URL": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Coordinates": {
            "LON": [
                39
            ],
            "LAT": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "ListValue": {
            "ID": [
                6
            ],
            "VALUE": [
                4
            ],
            "CODE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OfficeRecordset": {
            "info": [
                66
            ],
            "nodes": [
                68
            ],
            "__typename": [
                4
            ]
        },
        "CompanyVacancy": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                74
            ],
            "__typename": [
                4
            ]
        },
        "CompanyVacancyProps": {
            "PAYMENT": [
                4
            ],
            "RESPONSIBILITES": [
                60
            ],
            "WORK_EXPERIENCE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "VacancyRecordset": {
            "info": [
                66
            ],
            "nodes": [
                73
            ],
            "__typename": [
                4
            ]
        },
        "FaqQuestion": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "__typename": [
                4
            ]
        },
        "FaqQuestionRecordset": {
            "info": [
                66
            ],
            "nodes": [
                76
            ],
            "__typename": [
                4
            ]
        },
        "GeoObject": {
            "geo_lat": [
                39
            ],
            "geo_lon": [
                39
            ],
            "address_original": [
                4
            ],
            "address_full": [
                4
            ],
            "address_short": [
                4
            ],
            "street_path_full": [
                4
            ],
            "street_path_short": [
                4
            ],
            "region": [
                4
            ],
            "region_format": [
                4
            ],
            "region_original": [
                4
            ],
            "region_fias_id": [
                4
            ],
            "area": [
                4
            ],
            "area_format": [
                4
            ],
            "area_original": [
                4
            ],
            "area_fias_id": [
                4
            ],
            "city": [
                4
            ],
            "city_format": [
                4
            ],
            "city_original": [
                4
            ],
            "city_fias_id": [
                4
            ],
            "district": [
                4
            ],
            "district_format": [
                4
            ],
            "district_original": [
                4
            ],
            "district_fias_id": [
                4
            ],
            "street": [
                4
            ],
            "street_format": [
                4
            ],
            "street_original": [
                4
            ],
            "street_fias_id": [
                4
            ],
            "house": [
                4
            ],
            "house_format": [
                4
            ],
            "house_original": [
                4
            ],
            "house_fias_id": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "SearchSuggestion": {
            "label": [
                4
            ],
            "value": [
                4
            ],
            "data": [
                80
            ],
            "__typename": [
                4
            ]
        },
        "SearchSuggestionData": {
            "type": [
                4
            ],
            "entityTypeName": [
                4
            ],
            "entityTypeCode": [
                4
            ],
            "entityTypeId": [
                4
            ],
            "entityRole": [
                4
            ],
            "entityId": [
                6
            ],
            "entityTitle": [
                4
            ],
            "hint": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Offer": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "VID": [
                4
            ],
            "OFFER_NAME": [
                4
            ],
            "STARTUP_SHOW": [
                4
            ],
            "BANNER_INTERNAL_TEXT": [
                4
            ],
            "BANNER_HOR_MOBILE": [
                34
            ],
            "BANNER_HOR_DESKTOP": [
                34
            ],
            "BANNER_SQUARE": [
                34
            ],
            "DISCOUNT_ID": [
                6
            ],
            "CONTENT_IMAGE": [
                34
            ],
            "SLIDES": [
                82
            ],
            "ACTIONS_WEB": [
                32
            ],
            "ACTIONS_MOBILE": [
                83
            ],
            "IS_HOT": [
                5
            ],
            "VARS": [
                7
            ],
            "VIEW_MODE": [
                4
            ],
            "STICKY": [
                5
            ],
            "STICKY_TITLE": [
                4
            ],
            "STICKY_ICON": [
                4
            ],
            "FEATURES": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OfferSlide": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "CONTENT_TYPE": [
                4
            ],
            "CONTENT_IMAGE": [
                34
            ],
            "CONTENT_HTML": [
                4
            ],
            "BG_COLOR": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "MenuItemMobile": {
            "id": [
                4
            ],
            "parent": [
                4
            ],
            "label": [
                4
            ],
            "icon": [
                4
            ],
            "imageId": [
                6
            ],
            "image": [
                34
            ],
            "color": [
                4
            ],
            "backgroundColor": [
                4
            ],
            "outlineColor": [
                4
            ],
            "outlineWidth": [
                6
            ],
            "link": [
                5
            ],
            "outline": [
                5
            ],
            "labelColor": [
                4
            ],
            "badge": [
                7
            ],
            "params": [
                7
            ],
            "action": [
                84
            ],
            "condition": [
                85
            ],
            "templatable": [
                5
            ],
            "templatableProps": [
                4
            ],
            "roles": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "ActionMobile": {
            "code": [
                4
            ],
            "url": [
                4
            ],
            "title": [
                4
            ],
            "titleAuto": [
                5
            ],
            "replace": [
                5
            ],
            "addBacklink": [
                5
            ],
            "addSession": [
                5
            ],
            "await": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "Condition": {
            "path": [
                4
            ],
            "eq": [
                7
            ],
            "gt": [
                7
            ],
            "lt": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "OfferRecordset": {
            "info": [
                66
            ],
            "nodes": [
                81
            ],
            "__typename": [
                4
            ]
        },
        "PushSubscriber": {
            "ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "FortunePrize": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                89
            ],
            "PRIZE_TYPE": [
                90
            ],
            "BACKGROUND_COLOR": [
                4
            ],
            "TEXT_COLOR": [
                4
            ],
            "TEXT_ORIENTATION": [
                4
            ],
            "PROBABILITY": [
                6
            ],
            "GIFT_ELEMENT": [
                6
            ],
            "DISCOUNT_ELEMENT": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "FortunePrizeProps": {
            "BACKGROUND_COLOR": [
                4
            ],
            "TEXT_COLOR": [
                4
            ],
            "TEXT_ORIENTATION": [
                71
            ],
            "PROBABILITY": [
                39
            ],
            "PRIZE_TYPE": [
                90
            ],
            "GIFT_ELEMENT_ENTITY": [
                91
            ],
            "GIFT_ELEMENT": [
                39
            ],
            "DISCOUNT_ELEMENT_ENTITY": [
                91
            ],
            "DISCOUNT_ELEMENT": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "PrizeTypeEnum": {},
        "Element": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "__typename": [
                4
            ]
        },
        "FortuneUserPrize": {
            "ID": [
                6
            ],
            "USER_ID": [
                6
            ],
            "CREATED_AT": [
                6
            ],
            "PRIZE_ELEMENT_ID_ENTITY": [
                91
            ],
            "PRIZE_ELEMENT_ID": [
                6
            ],
            "IS_USED": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "HLEntityFilter": {
            "ID": [
                51
            ],
            "__typename": [
                4
            ]
        },
        "TelegramChat": {
            "ID": [
                6
            ],
            "CHAT_ID": [
                4
            ],
            "TELEGRAM_ID": [
                4
            ],
            "USER_ID": [
                6
            ],
            "PHONE": [
                4
            ],
            "STATUS": [
                4
            ],
            "CREATED_AT": [
                4
            ],
            "UPDATED_AT": [
                4
            ],
            "LAST_ACTIVITY": [
                4
            ],
            "UID": [
                4
            ],
            "CONTACT_PHONE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "TelegramChatRecordset": {
            "info": [
                66
            ],
            "nodes": [
                94
            ],
            "__typename": [
                4
            ]
        },
        "Webcam": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                97
            ],
            "__typename": [
                4
            ]
        },
        "WebcamProps": {
            "CODE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Review": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                99
            ],
            "ELEMENT": [
                91
            ],
            "CHILDREN": [
                98
            ],
            "ORDER": [
                100
            ],
            "__typename": [
                4
            ]
        },
        "ReviewProps": {
            "AUTHOR_USER_ID": [
                4
            ],
            "AUTHOR_NAME": [
                4
            ],
            "RATING": [
                39
            ],
            "ELEMENT_ID_ENTITY": [
                91
            ],
            "ELEMENT_ID": [
                39
            ],
            "CONTEXT_ID": [
                39
            ],
            "ANSWER": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Order": {
            "ID": [
                6
            ],
            "TS": [
                4
            ],
            "SYNCED": [
                5
            ],
            "SERVICE_ID": [
                6
            ],
            "PERSON_TYPE_ID": [
                6
            ],
            "URL": [
                4
            ],
            "USER_ID": [
                6
            ],
            "USER": [
                43
            ],
            "DATE_INSERT": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "DATE_UPDATE": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "DATE_PAYED": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "DATE_FORMATTED": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "DATE_TIME_FORMATTED": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "PRICE": [
                39
            ],
            "PRICE_BASKET": [
                39
            ],
            "PRICE_BASKET_BASE": [
                39
            ],
            "PRICE_DISCOUNT": [
                39
            ],
            "PRICE_DELIVERY": [
                39
            ],
            "PRICE_DELIVERY_BASE": [
                39
            ],
            "PRICE_TOTAL": [
                39
            ],
            "PRICE_TOTAL_BASE": [
                39
            ],
            "PRICE_PAY": [
                39
            ],
            "PRICE_PAY_BASE": [
                39
            ],
            "DISCOUNT_PERCENT": [
                39
            ],
            "DISCOUNT_REASON": [
                4
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                6
            ],
            "DELIVERY_ADDRESS_FULL": [
                4
            ],
            "DELIVERY_DATETIME": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "DELIVERY_ID": [
                6
            ],
            "DELIVERY": [
                101
            ],
            "DELIVERY_CALCULATED": [
                5
            ],
            "DELIVERY_DEPARTMENT": [
                68
            ],
            "PICKUP_DEPARTMENT": [
                68
            ],
            "PAYSYSTEM_ID": [
                6
            ],
            "PAYSYSTEM": [
                103
            ],
            "PAYSYSTEM_IS_ONLINE": [
                5
            ],
            "BASKET": [
                104
            ],
            "STATUS": [
                117
            ],
            "STATUS_ID": [
                4
            ],
            "STATUS_NAME": [
                4
            ],
            "STATUS_COLOR": [
                4
            ],
            "CSTATUS_ID": [
                4
            ],
            "CSTATUS_NAME": [
                4
            ],
            "CSTATUS_COLOR": [
                4
            ],
            "IS_PAID": [
                5
            ],
            "IS_ACTIVE": [
                5
            ],
            "IS_FINISHED": [
                5
            ],
            "IS_CANCELED": [
                5
            ],
            "IS_CAN_PAY": [
                5
            ],
            "IS_CAN_PAY_ONLINE": [
                5
            ],
            "IS_CAN_PAY_BILL": [
                5
            ],
            "IS_CAN_CANCEL": [
                5
            ],
            "USER_DESCRIPTION": [
                4
            ],
            "ACCESS_HASH": [
                4
            ],
            "SECRET_URL": [
                4
            ],
            "ACCOUNT_NUMBER": [
                4
            ],
            "PAYMENTS": [
                118
            ],
            "BUYER_NAME": [
                4
            ],
            "CONTRACT_NUM": [
                4
            ],
            "EDU_GROUP_NUM": [
                4
            ],
            "STUDENT_FIO": [
                4
            ],
            "PAY_LINK": [
                4
            ],
            "SCOPE": [
                119
            ],
            "SCOPE_ENTITY": [
                33
            ],
            "ACTIONS": [
                7
            ],
            "COUPONS": [
                120
            ],
            "BONUSES": [
                6
            ],
            "COURIER_STATE": [
                121
            ],
            "ADDRESS_FOR_1C": [
                4
            ],
            "CANCEL_REASONS": [
                122
            ],
            "ATTR_VALUE": [
                123
            ],
            "ATTR_VIEW": [
                129
            ],
            "ATTRS": [
                130
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryService": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "PARENT_ID": [
                6
            ],
            "TRANSPORT_TYPE": [
                102
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryTransportTypeEnum": {},
        "Paysystem": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "DESCRIPTION": [
                4
            ],
            "IS_INNER": [
                5
            ],
            "IS_ONLINE": [
                5
            ],
            "IS_ONLINE_DELAYED": [
                5
            ],
            "IS_BILL": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "BasketItem": {
            "ID": [
                6
            ],
            "UUID": [
                4
            ],
            "PARENT_ID": [
                6
            ],
            "PARENT_UUID": [
                4
            ],
            "ORDER_ID": [
                6
            ],
            "PRODUCT_ID": [
                6
            ],
            "NAME": [
                4
            ],
            "DESC": [
                4
            ],
            "QUANTITY": [
                39
            ],
            "BASE_PRICE": [
                39
            ],
            "PRICE_BASE": [
                39
            ],
            "PRICE": [
                39
            ],
            "FINAL_PRICE": [
                39
            ],
            "FINAL_PRICE_BASE": [
                39
            ],
            "MEASURE_NAME": [
                4
            ],
            "COMMENT": [
                4
            ],
            "PAID": [
                5
            ],
            "INPUT_PROPS_HASH": [
                4
            ],
            "DISABLE": [
                5
            ],
            "DISABLE_REASON": [
                4
            ],
            "BENEFIT": [
                105
            ],
            "DISCOUNTS": [
                106
            ],
            "CLIENT_CHANGED_AT": [
                6
            ],
            "ELEMENT": [
                109
            ],
            "BUILD": [
                115
            ],
            "MODIFICATORS": [
                7
            ],
            "PROPERTIES": [
                116
            ],
            "__typename": [
                4
            ]
        },
        "BasketItemBenefitType": {},
        "BasketItemDiscount": {
            "RULE": [
                4
            ],
            "TARGET": [
                107
            ],
            "TYPE": [
                108
            ],
            "AMOUNT": [
                39
            ],
            "DISCOUNTED_PRICE": [
                39
            ],
            "BASE_PRICE": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "BasketItemDiscountTarget": {},
        "BasketItemDiscountType": {},
        "Product": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                110
            ],
            "PRICE": [
                112
            ],
            "MEASURE": [
                113
            ],
            "PARENT": [
                109
            ],
            "OFFERS": [
                109
            ],
            "IS_SALE_SPECIAL": [
                5
            ],
            "SALES_COUNT": [
                6
            ],
            "HIT_POSITION": [
                6
            ],
            "HIT_SECTION_POSITION": [
                6
            ],
            "WEIGHT": [
                6
            ],
            "OFFER_PARENT_ELEMENT": [
                109
            ],
            "INGREDIENTS": [
                114
            ],
            "FEATURE_IDS": [
                6
            ],
            "IMAGE": [
                34
            ],
            "__typename": [
                4
            ]
        },
        "ProductProps": {
            "WEIGHT": [
                4
            ],
            "KKAL": [
                4
            ],
            "BELKI": [
                4
            ],
            "ZHIRY": [
                4
            ],
            "UGLEVODY": [
                4
            ],
            "ROLLS_ENTITIES": [
                91
            ],
            "ROLLS": [
                39
            ],
            "PHOTOV2": [
                34
            ],
            "COMPONENT_IS": [
                71
            ],
            "INGREDIENTS_ENTITIES": [
                91
            ],
            "INGREDIENTS": [
                39
            ],
            "SERVICE_ID": [
                4
            ],
            "SALE_SPECIAL": [
                5
            ],
            "FLAGS_ENTITIES": [
                91
            ],
            "FLAGS": [
                39
            ],
            "SET_ITEMS": [
                111
            ],
            "MODIFICATORS_ENTITIES": [
                91
            ],
            "MODIFICATORS": [
                39
            ],
            "FEATURES_ENTITIES": [
                91
            ],
            "FEATURES": [
                39
            ],
            "HIT_POSITION": [
                4
            ],
            "HIT_SECTION_POSITION": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ProductPropsSetItems": {
            "PRODUCT_ID_ENTITY": [
                91
            ],
            "PRODUCT_ID": [
                39
            ],
            "QUANTITY": [
                4
            ],
            "UID": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ProductPrice": {
            "PRICE": [
                39
            ],
            "DISCOUNTED": [
                39
            ],
            "DISCOUNT_PERCENT": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "ProductMeasure": {
            "NAME": [
                4
            ],
            "RATIO": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "Ingredient": {
            "ELEMENT_ID": [
                6
            ],
            "IS_REMOVABLE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "BasketBuildItem": {
            "PRODUCT_ID": [
                6
            ],
            "QUANTITY": [
                6
            ],
            "ELEMENT": [
                109
            ],
            "__typename": [
                4
            ]
        },
        "BasketItemProps": {
            "CATALOG_XML_ID": [
                4
            ],
            "PRODUCT_XML_ID": [
                4
            ],
            "PARENT_UUID": [
                4
            ],
            "IS_GIFT": [
                4
            ],
            "REASON_MOD_CODE": [
                4
            ],
            "REASON_MOD_ID": [
                6
            ],
            "REASON_RULE_CODE": [
                4
            ],
            "REASON_RULE_ID": [
                6
            ],
            "INGREDIENTS_REMOVED": [
                6
            ],
            "INGREDIENTS_ADDED": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "OrderStatus": {
            "ID": [
                4
            ],
            "NAME": [
                4
            ],
            "SORT": [
                6
            ],
            "COLOR": [
                4
            ],
            "TYPE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Payment": {
            "ID": [
                6
            ],
            "PAYSYSTEM_ID": [
                6
            ],
            "PAYSYSTEM": [
                103
            ],
            "IS_PAID": [
                5
            ],
            "SUM": [
                39
            ],
            "SUM_PAID": [
                39
            ],
            "PAY_NAV": [
                7
            ],
            "PS_STATUS": [
                4
            ],
            "PS_STATUS_CODE": [
                4
            ],
            "PS_STATUS_ID": [
                4
            ],
            "PS_STATUS_NAME": [
                4
            ],
            "PS_INVOICE_ID": [
                4
            ],
            "ORDER_ID": [
                4
            ],
            "ORDER_URL": [
                4
            ],
            "DATE_PAID": [
                7,
                {
                    "format": [
                        4
                    ],
                    "formatType": [
                        37
                    ]
                }
            ],
            "__typename": [
                4
            ]
        },
        "OrderScope": {
            "CONTRACT_NUM": [
                4
            ],
            "ENTITY_TYPE": [
                4
            ],
            "ENTITY_ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "Coupon": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "COUPON": [
                4
            ],
            "PRODUCT_ID": [
                6
            ],
            "PRODUCT": [
                109
            ],
            "__typename": [
                4
            ]
        },
        "CourierState": {
            "COORDS": [
                7
            ],
            "ARRIVAL_TIME_CAPTION": [
                4
            ],
            "ARRIVAL_TIME": [
                4
            ],
            "CAR_COLOR": [
                4
            ],
            "CAR_NUMBER": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderCancelReason": {
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderAttributesValue": {
            "DETAILS": [
                5
            ],
            "UUID": [
                4
            ],
            "FIO": [
                4
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "DELIVERY_TYPE": [
                7
            ],
            "DELIVERY_DEPARTMENT": [
                6
            ],
            "STREET_PATH": [
                4
            ],
            "CITY": [
                4
            ],
            "CITY_FIAS_ID": [
                4
            ],
            "SETTLEMENT": [
                4
            ],
            "SETTLEMENT_FIAS_ID": [
                4
            ],
            "STREET_FIAS_ID": [
                4
            ],
            "STREET_COORDS": [
                70
            ],
            "HOUSE": [
                4
            ],
            "HOUSE_FIAS_ID": [
                4
            ],
            "HOUSE_COORDS": [
                70
            ],
            "FLAT": [
                4
            ],
            "LOCATION": [
                4
            ],
            "INTERCOM": [
                4
            ],
            "FLOOR": [
                4
            ],
            "ENTRANCE": [
                4
            ],
            "PRIVATE_HOUSE": [
                5
            ],
            "LIFT": [
                5
            ],
            "PICKUP_DEPARTMENT": [
                7
            ],
            "TIME_MODE": [
                124
            ],
            "DATE": [
                4
            ],
            "TIME": [
                7
            ],
            "PAYMENT_TYPE": [
                125
            ],
            "CASH_SUM": [
                6
            ],
            "BONUSES": [
                4
            ],
            "PROMOCODE": [
                4
            ],
            "DELIVERY_PRICE": [
                6
            ],
            "RECEIVER_NAME": [
                4
            ],
            "RECEIVER_ANOTHER": [
                5
            ],
            "RECEIVER_PHONE": [
                4
            ],
            "PERSONS_NUMBER": [
                6
            ],
            "COMMENT": [
                4
            ],
            "GIFTS_LIST": [
                4
            ],
            "WITH_OPERATOR": [
                5
            ],
            "ROISTAT": [
                4
            ],
            "NEED_CONFIRM": [
                5
            ],
            "PROFILE_COMMENT": [
                4
            ],
            "ADDRESS_SOURCE": [
                4
            ],
            "PROFILE_ID": [
                6
            ],
            "ADDRESS_IS_CUSTOM": [
                5
            ],
            "PROFILE_DEFAULT": [
                5
            ],
            "VORDER_ID": [
                6
            ],
            "SERVICE_SEND": [
                5
            ],
            "DATETIME": [
                6
            ],
            "SERVICE_SEND_START": [
                6
            ],
            "DATA": [
                126
            ],
            "RESERVE_SUCCESS_HASH": [
                4
            ],
            "DISCOUNT_REASON": [
                4
            ],
            "DISCOUNT_PERCENT": [
                6
            ],
            "ADDRESS": [
                4
            ],
            "BENEFIT_TYPE": [
                127
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                4
            ],
            "STREET": [
                4
            ],
            "DEPARTMENT_SERVICE_ID": [
                6
            ],
            "DELIVERY_FREE_UPDATED_TIME": [
                6
            ],
            "IS_ACCEPTED": [
                5
            ],
            "TEST_TIME": [
                6
            ],
            "STRUCT": [
                7
            ],
            "TRANSPORT_TYPE": [
                128
            ],
            "COUPON_ID": [
                6
            ],
            "PRIZE_ID": [
                6
            ],
            "SESSION_ID": [
                4
            ],
            "PAYMENT_GIFT": [
                4
            ],
            "TEST_TIME_NEW": [
                6
            ],
            "APP_VERSION": [
                4
            ],
            "SOURCE": [
                4
            ],
            "RESERVE_REQUEST_TIME": [
                6
            ],
            "UTM_SOURCE": [
                4
            ],
            "RESERVE_AVAILABLE_TIME": [
                6
            ],
            "RESERVE_NEED_TIME": [
                6
            ],
            "RESERVE_STATUS": [
                4
            ],
            "RESERVE_SUCCESS_REQUEST_TIME": [
                6
            ],
            "UTM_MEDIUM": [
                4
            ],
            "UTM_CAMPAIGN": [
                4
            ],
            "UTM_TERM": [
                4
            ],
            "UTM_CONTENT": [
                4
            ],
            "UTM_LANDING_URL": [
                4
            ],
            "DELIVERY_ID": [
                6
            ],
            "PAY_SYSTEM_ID": [
                6
            ],
            "USER_DESCRIPTION": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "AttrTimeModeEnum": {},
        "AttrPaymentTypeEnum": {},
        "OrderData": {
            "paramInt": [
                6
            ],
            "paramString": [
                4
            ],
            "paramArray": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "BenefitTypeEnum": {},
        "AttrTransportTypeEnum": {},
        "OrderAttributesView": {
            "DETAILS": [
                4
            ],
            "UUID": [
                4
            ],
            "FIO": [
                4
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "DELIVERY_TYPE": [
                4
            ],
            "DELIVERY_DEPARTMENT": [
                4
            ],
            "STREET_PATH": [
                4
            ],
            "CITY": [
                4
            ],
            "CITY_FIAS_ID": [
                4
            ],
            "SETTLEMENT": [
                4
            ],
            "SETTLEMENT_FIAS_ID": [
                4
            ],
            "STREET_FIAS_ID": [
                4
            ],
            "STREET_COORDS": [
                4
            ],
            "HOUSE": [
                4
            ],
            "HOUSE_FIAS_ID": [
                4
            ],
            "HOUSE_COORDS": [
                4
            ],
            "FLAT": [
                4
            ],
            "LOCATION": [
                4
            ],
            "INTERCOM": [
                4
            ],
            "FLOOR": [
                4
            ],
            "ENTRANCE": [
                4
            ],
            "PRIVATE_HOUSE": [
                4
            ],
            "LIFT": [
                4
            ],
            "PICKUP_DEPARTMENT": [
                4
            ],
            "TIME_MODE": [
                4
            ],
            "DATE": [
                4
            ],
            "TIME": [
                4
            ],
            "PAYMENT_TYPE": [
                4
            ],
            "CASH_SUM": [
                4
            ],
            "BONUSES": [
                4
            ],
            "PROMOCODE": [
                4
            ],
            "DELIVERY_PRICE": [
                4
            ],
            "RECEIVER_NAME": [
                4
            ],
            "RECEIVER_ANOTHER": [
                4
            ],
            "RECEIVER_PHONE": [
                4
            ],
            "PERSONS_NUMBER": [
                4
            ],
            "COMMENT": [
                4
            ],
            "GIFTS_LIST": [
                4
            ],
            "WITH_OPERATOR": [
                4
            ],
            "ROISTAT": [
                4
            ],
            "NEED_CONFIRM": [
                4
            ],
            "PROFILE_COMMENT": [
                4
            ],
            "ADDRESS_SOURCE": [
                4
            ],
            "PROFILE_ID": [
                4
            ],
            "ADDRESS_IS_CUSTOM": [
                4
            ],
            "PROFILE_DEFAULT": [
                4
            ],
            "VORDER_ID": [
                4
            ],
            "SERVICE_SEND": [
                4
            ],
            "DATETIME": [
                4
            ],
            "SERVICE_SEND_START": [
                4
            ],
            "DATA": [
                4
            ],
            "RESERVE_SUCCESS_HASH": [
                4
            ],
            "DISCOUNT_REASON": [
                4
            ],
            "DISCOUNT_PERCENT": [
                4
            ],
            "ADDRESS": [
                4
            ],
            "BENEFIT_TYPE": [
                4
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                4
            ],
            "STREET": [
                4
            ],
            "DEPARTMENT_SERVICE_ID": [
                4
            ],
            "DELIVERY_FREE_UPDATED_TIME": [
                4
            ],
            "IS_ACCEPTED": [
                4
            ],
            "TEST_TIME": [
                4
            ],
            "STRUCT": [
                4
            ],
            "TRANSPORT_TYPE": [
                4
            ],
            "COUPON_ID": [
                4
            ],
            "PRIZE_ID": [
                4
            ],
            "SESSION_ID": [
                4
            ],
            "PAYMENT_GIFT": [
                4
            ],
            "TEST_TIME_NEW": [
                4
            ],
            "APP_VERSION": [
                4
            ],
            "SOURCE": [
                4
            ],
            "RESERVE_REQUEST_TIME": [
                4
            ],
            "UTM_SOURCE": [
                4
            ],
            "RESERVE_AVAILABLE_TIME": [
                4
            ],
            "RESERVE_NEED_TIME": [
                4
            ],
            "RESERVE_STATUS": [
                4
            ],
            "RESERVE_SUCCESS_REQUEST_TIME": [
                4
            ],
            "UTM_MEDIUM": [
                4
            ],
            "UTM_CAMPAIGN": [
                4
            ],
            "UTM_TERM": [
                4
            ],
            "UTM_CONTENT": [
                4
            ],
            "UTM_LANDING_URL": [
                4
            ],
            "DELIVERY_ID": [
                4
            ],
            "PAY_SYSTEM_ID": [
                4
            ],
            "USER_DESCRIPTION": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderAttribute": {
            "KIND": [
                131
            ],
            "TYPE": [
                132
            ],
            "CODE": [
                133
            ],
            "NAME": [
                4
            ],
            "DEFAULT_VALUE": [
                7
            ],
            "VALUE": [
                7
            ],
            "VALUE_VIEW": [
                7
            ],
            "OPTIONS": [
                134
            ],
            "__typename": [
                4
            ]
        },
        "OrderAttributeKindEnum": {},
        "OrderAttributeTypeEnum": {},
        "OrderAttributeCodeEnum": {},
        "OrderAttributeOption": {
            "ID": [
                6
            ],
            "VALUE": [
                7
            ],
            "NAME": [
                4
            ],
            "NAME_SHORT": [
                4
            ],
            "SORT": [
                6
            ],
            "DESCRIPTION": [
                4
            ],
            "XML_ID": [
                4
            ],
            "ICON": [
                4
            ],
            "DISABLE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "ProductFilterInput": {
            "ID": [
                51
            ],
            "NAME": [
                52
            ],
            "CODE": [
                52
            ],
            "SORT": [
                51
            ],
            "IBLOCK_ID": [
                51
            ],
            "IBLOCK_CODE": [
                52
            ],
            "IBLOCK_SECTION_ID": [
                51
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_DATE": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "AppProductRecordset": {
            "info": [
                66
            ],
            "nodes": [
                109
            ],
            "__typename": [
                4
            ]
        },
        "SearchResult": {
            "ELEMENTS": [
                109
            ],
            "SECTIONS": [
                55
            ],
            "__typename": [
                4
            ]
        },
        "SearchSuggestionDataInput": {
            "type": [
                4
            ],
            "entityTypeName": [
                4
            ],
            "entityTypeCode": [
                4
            ],
            "entityTypeId": [
                4
            ],
            "entityRole": [
                4
            ],
            "entityId": [
                6
            ],
            "entityTitle": [
                4
            ],
            "hint": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderFilter": {
            "ID": [
                51
            ],
            "ACCOUNT_NUMBER": [
                52
            ],
            "PAYED": [
                5
            ],
            "USER_ID": [
                51
            ],
            "EMAIL": [
                52
            ],
            "PHONE": [
                52
            ],
            "ELEMENT_NAME": [
                52
            ],
            "SECTION_ID": [
                51
            ],
            "PAY_SYSTEM_ID": [
                51
            ],
            "STATUS_ID": [
                52
            ],
            "CANCELED": [
                5
            ],
            "DATE_YEAR": [
                6
            ],
            "DATE_MONTH": [
                6
            ],
            "DATE_DAY": [
                6
            ],
            "DATE_PAYED_YEAR": [
                6
            ],
            "DATE_PAYED_MONTH": [
                6
            ],
            "DATE_PAYED_DAY": [
                6
            ],
            "PROP_FIO": [
                52
            ],
            "PROP_EMAIL": [
                52
            ],
            "PROP_PHONE": [
                52
            ],
            "PROP_PRODUCT_SECTIONS": [
                52
            ],
            "PROP_CONTRACT_NUM": [
                52
            ],
            "PROP_EDU_GROUP_NUM": [
                52
            ],
            "PROP_STUDENT_FIO": [
                52
            ],
            "MODE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "VorderCurrent": {
            "TS": [
                4
            ],
            "DELIVERY_PRICE_RULES": [
                141
            ],
            "BONUSES_AVAILABLE": [
                6
            ],
            "BONUSES_PERCENT": [
                6
            ],
            "PERSON_TYPES": [
                142
            ],
            "PAYMENT_TYPES": [
                143
            ],
            "PROFILES": [
                144
            ],
            "DEPARTMENTS": [
                68
            ],
            "DISCOUNTS": [
                146
            ],
            "DELIVERIES": [
                152
            ],
            "TRANSPORT_TYPES": [
                154
            ],
            "DELIVERY_CALCULATED": [
                5
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                39
            ],
            "COUPON_CAN_ADD": [
                5
            ],
            "RESPONSE_STATE": [
                155
            ],
            "BASKET_RULES": [
                160
            ],
            "ID": [
                6
            ],
            "SESSION_ID": [
                4
            ],
            "FUSER_ID": [
                6
            ],
            "USER_ID": [
                6
            ],
            "USER": [
                43
            ],
            "ORDER_ID": [
                6
            ],
            "FIELDS_RAW": [
                7
            ],
            "PROPS_RAW": [
                7
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "ORDER": [
                100
            ],
            "PROFILE_ID": [
                6
            ],
            "DELIVERY_DEPARTMENT_ID": [
                6
            ],
            "PICKUP_DEPARTMENT_ID": [
                6
            ],
            "DEPARTMENT_ID": [
                6
            ],
            "BONUSES": [
                6
            ],
            "COUPONS": [
                120
            ],
            "BASKET": [
                165,
                {
                    "recalc": [
                        5
                    ]
                }
            ],
            "ATTR": [
                123
            ],
            "ATTRS": [
                130
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryPriceRule": {
            "DATE": [
                4
            ],
            "PRICE": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "PersonType": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "SORT": [
                6
            ],
            "CODE": [
                4
            ],
            "RESTRICTED": [
                5
            ],
            "IS_COMPANY": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "PaymentType": {
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "ICON": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderProfile": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CAPTION": [
                4
            ],
            "USER_ID": [
                6
            ],
            "USER": [
                43
            ],
            "PERSON_TYPE_ID": [
                6
            ],
            "PERSON_TYPE": [
                142
            ],
            "COMPANY_ID": [
                6
            ],
            "IS_DEFAULT": [
                5
            ],
            "COORDS": [
                70
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                6
            ],
            "ATTR": [
                145
            ],
            "ATTRS": [
                130
            ],
            "__typename": [
                4
            ]
        },
        "OrderProfileAttributesValue": {
            "STREET_PATH": [
                4
            ],
            "CITY": [
                4
            ],
            "CITY_FIAS_ID": [
                4
            ],
            "SETTLEMENT": [
                4
            ],
            "SETTLEMENT_FIAS_ID": [
                4
            ],
            "STREET_FIAS_ID": [
                4
            ],
            "STREET_COORDS": [
                70
            ],
            "HOUSE": [
                4
            ],
            "HOUSE_FIAS_ID": [
                4
            ],
            "HOUSE_COORDS": [
                70
            ],
            "FLAT": [
                4
            ],
            "FLOOR": [
                4
            ],
            "ENTRANCE": [
                4
            ],
            "PRIVATE_HOUSE": [
                5
            ],
            "LIFT": [
                5
            ],
            "RECEIVER_NAME": [
                4
            ],
            "RECEIVER_ANOTHER": [
                5
            ],
            "RECEIVER_PHONE": [
                4
            ],
            "PROFILE_COMMENT": [
                4
            ],
            "ADDRESS_SOURCE": [
                4
            ],
            "ADDRESS_IS_CUSTOM": [
                5
            ],
            "PROFILE_DEFAULT": [
                5
            ],
            "ADDRESS": [
                4
            ],
            "STREET": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Discount": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                147
            ],
            "CONDITION": [
                150
            ],
            "DISCOUNT_PERCENT": [
                6
            ],
            "DISCOUNT_TARGET": [
                149
            ],
            "__typename": [
                4
            ]
        },
        "DiscountProps": {
            "TRANSPORT_TYPE": [
                102
            ],
            "PAYMENT_TYPE": [
                148
            ],
            "PRODUCT_ENTITIES": [
                91
            ],
            "PRODUCT": [
                39
            ],
            "PRODUCT_SECTION": [
                4
            ],
            "ORDER_PRICE_FROM": [
                39
            ],
            "NAME_TEMPLATE": [
                4
            ],
            "HOTEST": [
                5
            ],
            "DISCOUNT_PERCENT": [
                39
            ],
            "DELIVERY_DISCOUNT": [
                5
            ],
            "PRIZE_ENTITY": [
                91
            ],
            "PRIZE": [
                39
            ],
            "DISCOUNT_TARGET": [
                149
            ],
            "BENEFIT_TYPE": [
                127
            ],
            "__typename": [
                4
            ]
        },
        "PaymentTypeEnum": {},
        "DiscountTargetEnum": {},
        "OrderCondition": {
            "BENEFIT_TYPE": [
                127
            ],
            "PAYMENT_TYPE": [
                148
            ],
            "TRANSPORT_TYPE": [
                102
            ],
            "PRODUCT_SECTION": [
                6
            ],
            "PRODUCT": [
                6
            ],
            "OFFICE_ROLE": [
                151
            ],
            "OFFICE": [
                6
            ],
            "ORDER_PRICE_FROM": [
                6
            ],
            "COUPON": [
                6
            ],
            "PRIZE": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "OfficeRoleEnum": {},
        "DeliveryComputed": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "SERVICE": [
                153
            ],
            "CALC_TIMESTAMP": [
                6
            ],
            "PRICE": [
                39
            ],
            "PRICE_FORMATED": [
                4
            ],
            "DELIVERY_DISCOUNT_PRICE": [
                4
            ],
            "DELIVERY_DISCOUNT_PRICE_FORMATED": [
                4
            ],
            "PERIOD_TEXT": [
                4
            ],
            "CALCULATE_ERRORS": [
                7
            ],
            "CALCULATE_DESCRIPTION": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryWrapper": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "TRANSPORT_TYPE": [
                102
            ],
            "HOST": [
                101
            ],
            "__typename": [
                4
            ]
        },
        "TransportType": {
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "ICON": [
                4
            ],
            "DISCOUNT": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ResponseState": {
            "messages": [
                156
            ],
            "events": [
                7
            ],
            "rate": [
                158
            ],
            "redirect": [
                159
            ],
            "__typename": [
                4
            ]
        },
        "Message": {
            "id": [
                4
            ],
            "type": [
                157
            ],
            "code": [
                4
            ],
            "name": [
                4
            ],
            "status": [
                4
            ],
            "title": [
                4
            ],
            "message": [
                4
            ],
            "messages": [
                4
            ],
            "category": [
                4
            ],
            "notify": [
                5
            ],
            "rel": [
                4
            ],
            "duration": [
                6
            ],
            "data": [
                7
            ],
            "actions": [
                32
            ],
            "__typename": [
                4
            ]
        },
        "MessageTypeEnum": {},
        "ResponseRate": {
            "ttl": [
                6
            ],
            "limited": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "ResponseRedirect": {
            "ttl": [
                6
            ],
            "restricted": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "BasketRule": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                161
            ],
            "TYPE": [
                164
            ],
            "NAME_TEMPLATE": [
                4
            ],
            "ALL_STOP": [
                5
            ],
            "IS_ADDITIONAL": [
                5
            ],
            "CONDITION": [
                150
            ],
            "BENEFITS": [
                17
            ],
            "PROMO": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "BasketRuleProps": {
            "TYPE": [
                18
            ],
            "CAPTION": [
                4
            ],
            "NAME_TEMPLATE": [
                4
            ],
            "IS_ADDITIONAL": [
                5
            ],
            "ALL_STOP": [
                5
            ],
            "CONDITION_PAYMENT_TYPE": [
                148
            ],
            "CONDITION_TRANSPORT_TYPE": [
                102
            ],
            "CONDITION_ORDER_PRICE_FROM": [
                39
            ],
            "CONDITION_PRODUCT_SECTION": [
                4
            ],
            "CONDITION_PRODUCT_ENTITIES": [
                91
            ],
            "CONDITION_PRODUCT": [
                39
            ],
            "CONDITION_OFFICE_ENTITIES": [
                91
            ],
            "CONDITION_OFFICE": [
                39
            ],
            "CONDITION_OFFICE_ROLE": [
                162
            ],
            "CONDITION_BENEFIT_TYPE": [
                127
            ],
            "CONDITION_COUPON_ENTITY": [
                91
            ],
            "CONDITION_COUPON": [
                39
            ],
            "CONDITION_PRIZE_ENTITY": [
                91
            ],
            "CONDITION_PRIZE": [
                39
            ],
            "BENEFITS": [
                163
            ],
            "DISCOUNT_PERCENT": [
                39
            ],
            "BENEFITS_PRODUCT_ID_ENTITIES": [
                91
            ],
            "PRODUCT_ID": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "OfferRoleEnum": {},
        "BasketRulePropsBenefits": {
            "TYPE": [
                18
            ],
            "DISCOUNT_PERCENT": [
                39
            ],
            "PRODUCT_ID": [
                39
            ],
            "UID": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "BasketRuleTypeEnum": {},
        "Basket": {
            "TS": [
                4
            ],
            "SYNCED": [
                5
            ],
            "BASE_PRICE": [
                39
            ],
            "PRICE": [
                39
            ],
            "COUNT": [
                6
            ],
            "QUANTITY": [
                39
            ],
            "ITEMS": [
                104
            ],
            "WEIGHT": [
                39
            ],
            "MIN_PRICE": [
                39
            ],
            "MIN_PRICE_REACHED": [
                5
            ],
            "HASH": [
                4
            ],
            "OFFERS": [
                166
            ],
            "GIFTS": [
                6
            ],
            "CLIENT_CHANGED_AT": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "SpecialOffer": {
            "MIN_PRICE": [
                6
            ],
            "MODE": [
                4
            ],
            "ELEMENT_ID": [
                6
            ],
            "ELEMENT": [
                109
            ],
            "TYPE": [
                4
            ],
            "TYPE_INFO": [
                167
            ],
            "__typename": [
                4
            ]
        },
        "SpecialOfferType": {
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "COLOR": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "VorderSummary": {
            "ID": [
                6
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "FUSER_ID": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "OrderProfileRecordset": {
            "info": [
                66
            ],
            "nodes": [
                144
            ],
            "__typename": [
                4
            ]
        },
        "ClientCardFilterInput": {
            "ID": [
                51
            ],
            "BONUSES": [
                51
            ],
            "FETCHED": [
                5
            ],
            "FETCHED_TIME": [
                171
            ],
            "USER_ID": [
                51
            ],
            "CLIENT_PHONE": [
                52
            ],
            "LEVEL_CODE": [
                52
            ],
            "LEVEL_NAME": [
                52
            ],
            "MONTH_SPENT": [
                51
            ],
            "BONUSES_EXPIRE": [
                171
            ],
            "BONUSES_PERCENT": [
                51
            ],
            "DIS_FIRST_ORDER": [
                51
            ],
            "DIS_SELF_PICKUP": [
                51
            ],
            "__typename": [
                4
            ]
        },
        "DateFilterInput": {
            "eq": [
                4
            ],
            "in": [
                4
            ],
            "not": [
                4
            ],
            "gt": [
                4
            ],
            "lt": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "SaleClientCard": {
            "ID": [
                6
            ],
            "BONUSES": [
                6
            ],
            "FETCHED": [
                5
            ],
            "FETCHED_TIME_FORMATTED": [
                4
            ],
            "FETCHED_TIME": [
                6
            ],
            "USER_ID": [
                6
            ],
            "CLIENT_PHONE": [
                4
            ],
            "LEVEL_CODE": [
                4
            ],
            "LEVEL_NAME": [
                4
            ],
            "MONTH_SPENT": [
                39
            ],
            "BONUSES_EXPIRE_FORMATTED": [
                4
            ],
            "BONUSES_EXPIRE": [
                6
            ],
            "BONUSES_PERCENT": [
                39
            ],
            "DIS_FIRST_ORDER": [
                39
            ],
            "DIS_SELF_PICKUP": [
                39
            ],
            "LEVEL": [
                173
            ],
            "DISCOUNTS": [
                146
            ],
            "FETCHED_ACTUAL": [
                5
            ],
            "EXPIRED": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "BonusLevel": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                174
            ],
            "__typename": [
                4
            ]
        },
        "BonusLevelProps": {
            "ORDERS_SUMM": [
                4
            ],
            "ACCUMULATION_PERCENT": [
                39
            ],
            "MAX_USE_PERCENT": [
                39
            ],
            "COLOR": [
                4
            ],
            "MONTH_SPENT_MIN": [
                39
            ],
            "MONTH_SPENT_MAX": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "ClientCardRecordset": {
            "info": [
                66
            ],
            "nodes": [
                172
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryZone": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                7,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PROPERTIES": [
                177
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryZoneProps": {
            "PRICE_TEXT": [
                4
            ],
            "PRICE_BY_DELIVERY": [
                39
            ],
            "PRICE_BY_KM": [
                39
            ],
            "FREE_TEXT": [
                4
            ],
            "FREE_FROM_PRICE": [
                39
            ],
            "GEOJSON": [
                7
            ],
            "OUTSIDE": [
                5
            ],
            "COLOR": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ProductIngredient": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "URL": [
                4
            ],
            "PROPERTIES": [
                179
            ],
            "__typename": [
                4
            ]
        },
        "ProductIngredientProps": {
            "SHOW_IN_FILTER": [
                5
            ],
            "ALIASES": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "Modificator": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "SECTION": [
                181
            ],
            "TYPE": [
                183
            ],
            "LIMIT": [
                6
            ],
            "QUANTITY_LIMIT": [
                6
            ],
            "REQUIRED": [
                5
            ],
            "IS_GLOBAL": [
                5
            ],
            "ORDER_PRICE_FROM": [
                39
            ],
            "CONDITION": [
                150
            ],
            "PRODUCT_COMPONENT": [
                4
            ],
            "PRODUCT_COMPONENT_PROPS": [
                7
            ],
            "PRODUCT_COMPONENT_STYLE": [
                7
            ],
            "OPTIONS": [
                186
            ],
            "CODE_PATH": [
                4
            ],
            "ID_PATH": [
                4
            ],
            "DEFAULT_VALUE": [
                7
            ],
            "GROUP_CODE": [
                4
            ],
            "POSITIONS": [
                4
            ],
            "OPTION_INFO_TYPE": [
                185
            ],
            "FEATURES": [
                6
            ],
            "PROPERTIES": [
                187
            ],
            "__typename": [
                4
            ]
        },
        "ModificatorSection": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_TYPE_ID": [
                4
            ],
            "IBLOCK_EXTERNAL_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE": [
                5
            ],
            "PICTURE": [
                34
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DESCRIPTION": [
                4
            ],
            "DESCRIPTION_TYPE": [
                4
            ],
            "LEFT_MARGIN": [
                6
            ],
            "RIGHT_MARGIN": [
                6
            ],
            "DEPTH_LEVEL": [
                6
            ],
            "SEARCHABLE_CONTENT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "SECTION_PAGE_URL": [
                4
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "PARENT": [
                181
            ],
            "PARENTS": [
                181
            ],
            "ELEMENT_CNT": [
                6
            ],
            "META": [
                56
            ],
            "REPLACE_LINK": [
                4
            ],
            "CHILDREN": [
                55
            ],
            "PROPERTIES": [
                182
            ],
            "__typename": [
                4
            ]
        },
        "ModificatorSectionProps": {
            "LIMIT": [
                39
            ],
            "TYPE": [
                183
            ],
            "REQUIRED": [
                5
            ],
            "QUANTITY_LIMIT": [
                6
            ],
            "PRODUCT_COMPONENT": [
                4
            ],
            "PRODUCT_COM_PROPS": [
                4
            ],
            "IS_GROUP": [
                5
            ],
            "PRODUCT_COM_STYLE": [
                4
            ],
            "CARD_POS": [
                184
            ],
            "OPTION_INFO_TYPE": [
                185
            ],
            "__typename": [
                4
            ]
        },
        "ModificatorTypeEnum": {},
        "ProductModificatorCardPositionEnum": {},
        "ProductModificatorOptionInfoTypeEnum": {},
        "ModificatorOption": {
            "UID": [
                4
            ],
            "NAME": [
                4
            ],
            "PRODUCT_ID": [
                6
            ],
            "QUANTITY": [
                6
            ],
            "QUANTITY_LIMIT": [
                6
            ],
            "IMAGE": [
                34
            ],
            "DEFAULT": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "ModificatorProps": {
            "OVERRIDE_PARENT": [
                5
            ],
            "TYPE": [
                183
            ],
            "REQUIRED": [
                188
            ],
            "LIMIT": [
                39
            ],
            "QUANTITY_LIMIT": [
                39
            ],
            "PRODUCT_COMPONENT": [
                4
            ],
            "PRODUCT_COMPONENT_PROPS": [
                4
            ],
            "PRODUCT_COMPONENT_STYLE": [
                4
            ],
            "CARD_POSITION": [
                184
            ],
            "DETAIL_POSITION": [
                189
            ],
            "PRODUCTS": [
                190
            ],
            "PRODUCTS_PRODUCT_ID_ENTITIES": [
                91
            ],
            "PRODUCT_ID": [
                39
            ],
            "QUANTITY": [
                39
            ],
            "UID": [
                4
            ],
            "NAME": [
                4
            ],
            "IMAGE": [
                34
            ],
            "DEFAULT": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "LogicEnum": {},
        "ProductModificatorDetailPositionEnum": {},
        "ModificatorPropsProducts": {
            "PRODUCT_ID": [
                39
            ],
            "QUANTITY": [
                39
            ],
            "QUANTITY_LIMIT": [
                39
            ],
            "UID": [
                4
            ],
            "NAME": [
                4
            ],
            "IMAGE": [
                34
            ],
            "DEFAULT": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "ProductFlag": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "URL": [
                4
            ],
            "PROPERTIES": [
                192
            ],
            "__typename": [
                4
            ]
        },
        "ProductFlagProps": {
            "NAME_SHORT": [
                4
            ],
            "TEXT_COLOR": [
                4
            ],
            "BG_COLOR": [
                4
            ],
            "IMAGE": [
                34
            ],
            "ICON": [
                4
            ],
            "CLASS": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderRestriction": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                194
            ],
            "SCHEDULE": [
                7
            ],
            "SCHEDULE_DESC": [
                4
            ],
            "SCHEDULE_ACTIVE": [
                5
            ],
            "CONDITION": [
                150
            ],
            "ITEM_ERROR_NAME": [
                4
            ],
            "ITEM_MESSAGE": [
                4
            ],
            "MESSAGE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderRestrictionProps": {
            "TRANSPORT_TYPE": [
                102
            ],
            "OFFICE_ROLE": [
                151
            ],
            "OFFICE_ENTITIES": [
                91
            ],
            "OFFICE": [
                39
            ],
            "PAYMENT_TYPE": [
                148
            ],
            "PRODUCT_ENTITIES": [
                91
            ],
            "PRODUCT": [
                39
            ],
            "PRODUCT_SECTION": [
                4
            ],
            "MESSAGE": [
                4
            ],
            "ITEM_MESSAGE": [
                4
            ],
            "SCHEDULE": [
                7
            ],
            "ITEM_ERROR_NAME": [
                3
            ],
            "SECTION": [
                21
            ],
            "__typename": [
                4
            ]
        },
        "SectionFilterInput": {
            "ID": [
                51
            ],
            "ACTIVE": [
                5
            ],
            "GLOBAL_ACTIVE": [
                5
            ],
            "NAME": [
                52
            ],
            "CODE": [
                52
            ],
            "XML_ID": [
                52
            ],
            "SECTION_ID": [
                51
            ],
            "DEPTH_LEVEL": [
                51
            ],
            "LEFT_BORDER": [
                51
            ],
            "RIGHT_BORDER": [
                51
            ],
            "LEFT_MARGIN": [
                51
            ],
            "RIGHT_MARGIN": [
                51
            ],
            "IBLOCK_ID": [
                51
            ],
            "IBLOCK_ACTIVE": [
                5
            ],
            "IBLOCK_NAME": [
                52
            ],
            "IBLOCK_TYPE": [
                52
            ],
            "HAS_ELEMENT": [
                51
            ],
            "MENU_BG_COLOR": [
                52
            ],
            "TITLE_IRKUTSK": [
                52
            ],
            "DESCR_IRKUTSK": [
                52
            ],
            "H1_IRKUTSK": [
                52
            ],
            "TITLE_ANGARSK": [
                52
            ],
            "DESCR_ANGARSK": [
                52
            ],
            "H1_ANGARSK": [
                52
            ],
            "TITLE_KRASNOYARSK": [
                52
            ],
            "DESCR_KRASNOYARSK": [
                52
            ],
            "H1_KRASNOYARSK": [
                52
            ],
            "NAV_URL": [
                52
            ],
            "NAV_TITLE": [
                52
            ],
            "HINT": [
                52
            ],
            "CATEGORY_CLASS": [
                52
            ],
            "SEARCH_IN": [
                52
            ],
            "REPLACE_LINK": [
                52
            ],
            "M_CARD": [
                52
            ],
            "MENU_ICON": [
                52
            ],
            "MENU_FOCUSED_ICON": [
                52
            ],
            "MENU_ITEM_STYLE": [
                52
            ],
            "MENU_COLOR": [
                52
            ],
            "UPSALE_SECTIONS": [
                52
            ],
            "MODIFICATORS": [
                52
            ],
            "__typename": [
                4
            ]
        },
        "ProductSection": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_TYPE_ID": [
                4
            ],
            "IBLOCK_EXTERNAL_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE": [
                5
            ],
            "PICTURE": [
                34
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DESCRIPTION": [
                4
            ],
            "DESCRIPTION_TYPE": [
                4
            ],
            "LEFT_MARGIN": [
                6
            ],
            "RIGHT_MARGIN": [
                6
            ],
            "DEPTH_LEVEL": [
                6
            ],
            "SEARCHABLE_CONTENT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "SECTION_PAGE_URL": [
                4
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "PARENT": [
                196
            ],
            "PARENTS": [
                196
            ],
            "ELEMENT_CNT": [
                6
            ],
            "META": [
                56
            ],
            "REPLACE_LINK": [
                4
            ],
            "CHILDREN": [
                55
            ],
            "PROPERTIES": [
                197
            ],
            "FEATURE_IDS": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "ProductSectionProps": {
            "MENU_BG_COLOR": [
                4
            ],
            "TITLE_IRKUTSK": [
                4
            ],
            "DESCR_IRKUTSK": [
                4
            ],
            "H1_IRKUTSK": [
                4
            ],
            "TITLE_ANGARSK": [
                4
            ],
            "DESCR_ANGARSK": [
                4
            ],
            "H1_ANGARSK": [
                4
            ],
            "TITLE_KRASNOYARSK": [
                4
            ],
            "DESCR_KRASNOYARSK": [
                4
            ],
            "H1_KRASNOYARSK": [
                4
            ],
            "NAV_URL": [
                4
            ],
            "NAV_TITLE": [
                4
            ],
            "HINT": [
                4
            ],
            "CATEGORY_CLASS": [
                4
            ],
            "SEARCH_IN": [
                4
            ],
            "REPLACE_LINK": [
                4
            ],
            "M_CARD": [
                4
            ],
            "MENU_ICON": [
                34
            ],
            "MENU_FOCUSED_ICON": [
                34
            ],
            "MENU_ITEM_STYLE": [
                198
            ],
            "MENU_COLOR": [
                4
            ],
            "UPSALE_SECTIONS": [
                6
            ],
            "MODIFICATORS_ENTITY": [
                180
            ],
            "MODIFICATORS": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "ButtonStyleEnum": {},
        "ClientSegment": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "__typename": [
                4
            ]
        },
        "ClientSegmentRecordset": {
            "info": [
                66
            ],
            "nodes": [
                199
            ],
            "__typename": [
                4
            ]
        },
        "Feature": {
            "ACTIVE": [
                5
            ],
            "AVAILABLE": [
                202
            ],
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                203
            ],
            "__typename": [
                4
            ]
        },
        "AvailableStatus": {
            "STATUS": [
                5
            ],
            "REASON": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "FeatureProps": {
            "MODEL_CLASS": [
                4
            ],
            "SEGMENTS_ENTITIES": [
                91
            ],
            "SEGMENTS": [
                39
            ],
            "SCHEDULE_ENABLE": [
                5
            ],
            "SCHEDULE": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "FeatureRecordset": {
            "info": [
                66
            ],
            "nodes": [
                201
            ],
            "__typename": [
                4
            ]
        },
        "CallTrackingPhone": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "PROPERTIES": [
                206
            ],
            "PHONE_NUMBER": [
                4
            ],
            "IS_DEFAULT": [
                5
            ],
            "IS_RESERVED": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "CallTrackingPhoneProps": {
            "PHONE_NUMBER": [
                4
            ],
            "CLIENT_ID": [
                4
            ],
            "USER_ID": [
                39
            ],
            "RESERVED_AT": [
                6
            ],
            "IS_DEFAULT": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "YandexMetricGoal": {
            "ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "SORT": [
                6
            ],
            "IBLOCK_ID": [
                6
            ],
            "IBLOCK_CODE": [
                4
            ],
            "IBLOCK_SECTION_ID": [
                6
            ],
            "ACTIVE": [
                5
            ],
            "ACTIVE_FROM": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "ACTIVE_TO": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TIMESTAMP_X": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "DATE_CREATE": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "CREATED_BY": [
                6
            ],
            "CREATED_USER_NAME": [
                4
            ],
            "MODIFIED_BY": [
                6
            ],
            "PREVIEW_PICTURE": [
                34
            ],
            "PREVIEW_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "PREVIEW_TEXT_TYPE": [
                4
            ],
            "DETAIL_PICTURE": [
                34
            ],
            "DETAIL_TEXT": [
                4,
                {
                    "format": [
                        5
                    ]
                }
            ],
            "DETAIL_TEXT_TYPE": [
                4
            ],
            "SHOW_COUNTER": [
                6
            ],
            "SHOW_COUNTER_START": [
                7,
                {
                    "format": [
                        4
                    ]
                }
            ],
            "TAGS": [
                4
            ],
            "XML_ID": [
                4
            ],
            "EXTERNAL_ID": [
                4
            ],
            "SECTION_ID": [
                6
            ],
            "IBLOCK_SECTION_IDS": [
                6
            ],
            "URL": [
                4
            ],
            "PATH": [
                55
            ],
            "SECTIONS": [
                55
            ],
            "SECTION": [
                55
            ],
            "ROOT_SECTION": [
                55
            ],
            "META": [
                56
            ],
            "__typename": [
                4
            ]
        },
        "YandexMetricGoalRecordset": {
            "info": [
                66
            ],
            "nodes": [
                207
            ],
            "__typename": [
                4
            ]
        },
        "Mutation": {
            "testMutationcreate": [
                211,
                {
                    "model": [
                        210,
                        "TestItemInput!"
                    ]
                }
            ],
            "testMutationupdate": [
                212,
                {
                    "id": [
                        6,
                        "Int!"
                    ],
                    "model": [
                        210,
                        "TestItemInput!"
                    ]
                }
            ],
            "testMutationdelete": [
                213,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "hook_mutation": [
                213
            ],
            "notice_pub_sync_readed": [
                214,
                {
                    "ids": [
                        7
                    ]
                }
            ],
            "notice_pub_push_send_queue": [
                213
            ],
            "notice_pub_push_update_token": [
                213,
                {
                    "pushToken": [
                        4
                    ]
                }
            ],
            "user_auth_create_sa": [
                213,
                {
                    "phone": [
                        4
                    ],
                    "clientIds": [
                        7
                    ],
                    "code": [
                        4
                    ]
                }
            ],
            "user_auth_login_start": [
                216,
                {
                    "phone": [
                        4
                    ],
                    "captcha": [
                        215
                    ]
                }
            ],
            "user_auth_login_request": [
                220,
                {
                    "confirmMode": [
                        4
                    ],
                    "phone": [
                        4
                    ],
                    "captcha": [
                        215
                    ],
                    "token": [
                        4
                    ]
                }
            ],
            "user_auth_login_confirm": [
                222,
                {
                    "confirmMode": [
                        4
                    ],
                    "phone": [
                        4
                    ],
                    "captcha": [
                        215
                    ],
                    "code": [
                        4
                    ],
                    "sid": [
                        4
                    ],
                    "clientId": [
                        4
                    ],
                    "disableBasketTransfer": [
                        5
                    ],
                    "pushToken": [
                        4
                    ]
                }
            ],
            "user_app_client": [
                213,
                {
                    "debugParams": [
                        7
                    ],
                    "mobilePushToken": [
                        4
                    ],
                    "webPushToken": [
                        4
                    ]
                }
            ],
            "user_profile_save": [
                213,
                {
                    "form": [
                        7
                    ]
                }
            ],
            "user_logout": [
                213
            ],
            "user_profile_name": [
                224,
                {
                    "name": [
                        4
                    ]
                }
            ],
            "user_profile_birthday": [
                225,
                {
                    "birthday": [
                        4
                    ]
                }
            ],
            "user_profile_email": [
                226,
                {
                    "action": [
                        4
                    ],
                    "email": [
                        4
                    ],
                    "code": [
                        4
                    ]
                }
            ],
            "company_office_update": [
                230,
                {
                    "id": [
                        6,
                        "Int!"
                    ],
                    "model": [
                        227,
                        "CompanyOfficeInput!"
                    ]
                }
            ],
            "company_vacancy_order": [
                213,
                {
                    "id": [
                        6
                    ],
                    "model": [
                        7
                    ]
                }
            ],
            "push_subscribe": [
                231,
                {
                    "endpoint": [
                        4,
                        "String!"
                    ],
                    "p256dhKey": [
                        4,
                        "String!"
                    ],
                    "authToken": [
                        4,
                        "String!"
                    ]
                }
            ],
            "push_unsubscribe": [
                233
            ],
            "push_send_test": [
                235,
                {
                    "title": [
                        4,
                        "String!"
                    ],
                    "body": [
                        4,
                        "String!"
                    ],
                    "data": [
                        7
                    ]
                }
            ],
            "fortune_spin": [
                237
            ],
            "telegram_create": [
                240,
                {
                    "model": [
                        239,
                        "TelegramChatInput!"
                    ]
                }
            ],
            "telegram_update": [
                241,
                {
                    "id": [
                        6,
                        "Int!"
                    ],
                    "model": [
                        239,
                        "TelegramChatInput!"
                    ]
                }
            ],
            "telegram_delete": [
                213,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "telegram_auth_by_phone": [
                242,
                {
                    "phone": [
                        4,
                        "String!"
                    ],
                    "chatId": [
                        4,
                        "String!"
                    ],
                    "telegramId": [
                        4,
                        "String!"
                    ]
                }
            ],
            "review_service_review": [
                244,
                {
                    "model": [
                        7
                    ]
                }
            ],
            "review_order_guest_review": [
                245,
                {
                    "type": [
                        4
                    ],
                    "orderServiceId": [
                        6
                    ]
                }
            ],
            "catalog_product_order": [
                213,
                {
                    "elementId": [
                        6
                    ],
                    "model": [
                        7
                    ]
                }
            ],
            "sale_order_test": [
                247
            ],
            "sale_order_pay_online": [
                249,
                {
                    "id": [
                        6
                    ],
                    "hash": [
                        4
                    ],
                    "type": [
                        4
                    ],
                    "savePaymentType": [
                        5
                    ]
                }
            ],
            "sale_order_repeat": [
                251,
                {
                    "id": [
                        6
                    ],
                    "hash": [
                        4
                    ]
                }
            ],
            "sale_order_cancel": [
                252,
                {
                    "id": [
                        6
                    ],
                    "hash": [
                        4
                    ],
                    "reason": [
                        4
                    ],
                    "comment": [
                        4
                    ]
                }
            ],
            "vorder_new": [
                253
            ],
            "vorder_apply": [
                259,
                {
                    "order": [
                        256
                    ],
                    "params": [
                        7
                    ]
                }
            ],
            "vorder_basket": [
                261,
                {
                    "order": [
                        256
                    ],
                    "action": [
                        4
                    ],
                    "build": [
                        7
                    ]
                }
            ],
            "vorder_delivery_calculate": [
                265,
                {
                    "order": [
                        256
                    ],
                    "calc": [
                        263
                    ]
                }
            ],
            "vorder_coupon": [
                269,
                {
                    "order": [
                        256
                    ],
                    "action": [
                        4
                    ],
                    "couponCode": [
                        4
                    ],
                    "orderPrice": [
                        6
                    ]
                }
            ],
            "vorder_submit": [
                271,
                {
                    "order": [
                        256
                    ]
                }
            ],
            "vorder_sync": [
                273,
                {
                    "order": [
                        256
                    ]
                }
            ],
            "sale_profile_default": [
                275,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "sale_profile_delete": [
                276,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "sale_profile_save": [
                277,
                {
                    "id": [
                        6
                    ],
                    "attrs": [
                        257
                    ]
                }
            ],
            "sale_profile_calc_delivery": [
                278,
                {
                    "profileId": [
                        6
                    ],
                    "attrs": [
                        257
                    ],
                    "basket": [
                        7
                    ],
                    "timeMode": [
                        264
                    ],
                    "timeNeed": [
                        6
                    ]
                }
            ],
            "sale_client_card_create": [
                280,
                {
                    "model": [
                        279,
                        "ElementInput!"
                    ]
                }
            ],
            "sale_client_card_update": [
                281,
                {
                    "id": [
                        6,
                        "Int!"
                    ],
                    "model": [
                        279,
                        "ElementInput!"
                    ]
                }
            ],
            "sale_client_card_delete": [
                213,
                {
                    "id": [
                        6
                    ]
                }
            ],
            "call_tracking_request_phone": [
                282
            ],
            "__typename": [
                4
            ]
        },
        "TestItemInput": {
            "name": [
                4
            ],
            "description": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "TestmutationcreateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                23
            ],
            "__typename": [
                4
            ]
        },
        "TestmutationupdateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                23
            ],
            "__typename": [
                4
            ]
        },
        "Response": {
            "success": [
                5
            ],
            "state": [
                155
            ],
            "payload": [
                7
            ],
            "error": [
                1
            ],
            "errors": [
                1
            ],
            "__typename": [
                4
            ]
        },
        "NoticePubSyncReadedResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                38
            ],
            "__typename": [
                4
            ]
        },
        "CaptchaInput": {
            "SID": [
                4
            ],
            "PROVIDER": [
                4
            ],
            "ANSWER": [
                4
            ],
            "VALUE": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginStartResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                217
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginStartResultPayload": {
            "confirmModes": [
                218
            ],
            "discounts": [
                146
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthConfirm": {
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "COLOR": [
                4
            ],
            "ICON": [
                4
            ],
            "LIST_NAME": [
                4
            ],
            "LIST_CAPTION": [
                4
            ],
            "LIST_BUTTON_MOBILE": [
                83
            ],
            "LIST_BUTTON_WEB": [
                32
            ],
            "CONFIRM_CONTENT_MOBILE": [
                4
            ],
            "CONFIRM_CONTENT_WEB": [
                4
            ],
            "CONFIRM_STEPS": [
                219
            ],
            "RESEND_TITLE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthConfirmStep": {
            "CODE": [
                4
            ],
            "NAME": [
                4
            ],
            "CAPTION": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginRequestResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                221
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginRequestResultPayload": {
            "rateTtl": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginConfirmResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                223
            ],
            "__typename": [
                4
            ]
        },
        "UserAuthLoginConfirmResultPayload": {
            "appClient": [
                48
            ],
            "sessionId": [
                4
            ],
            "userId": [
                6
            ],
            "redirect": [
                7
            ],
            "isNew": [
                5
            ],
            "__typename": [
                4
            ]
        },
        "UserProfileNameResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                43
            ],
            "__typename": [
                4
            ]
        },
        "UserProfileBirthdayResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                43
            ],
            "__typename": [
                4
            ]
        },
        "UserProfileEmailResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                43
            ],
            "__typename": [
                4
            ]
        },
        "CompanyOfficeInput": {
            "IBLOCK_ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "PROPERTIES": [
                228
            ],
            "__typename": [
                4
            ]
        },
        "CompanyOfficeInputProps": {
            "MAIN": [
                4
            ],
            "ADDRESS": [
                4
            ],
            "PHONES": [
                4
            ],
            "EMAIL": [
                4
            ],
            "COORDINATES": [
                229
            ],
            "REQUISITES": [
                4
            ],
            "ROLES": [
                6
            ],
            "WORKTIME": [
                4
            ],
            "SERVICE_ID": [
                4
            ],
            "PAYSYSTEM_ID": [
                6
            ],
            "GIS_URL": [
                4
            ],
            "INFO_URL": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "CoordinatesInput": {
            "LON": [
                39
            ],
            "LAT": [
                39
            ],
            "__typename": [
                4
            ]
        },
        "CompanyOfficeUpdateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                68
            ],
            "__typename": [
                4
            ]
        },
        "PushSubscribeResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                232
            ],
            "__typename": [
                4
            ]
        },
        "PushSubscribeResultPayload": {
            "appClient": [
                48
            ],
            "__typename": [
                4
            ]
        },
        "PushUnsubscribeResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                234
            ],
            "__typename": [
                4
            ]
        },
        "PushUnsubscribeResultPayload": {
            "appClient": [
                48
            ],
            "__typename": [
                4
            ]
        },
        "PushSendTestResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                236
            ],
            "__typename": [
                4
            ]
        },
        "PushSendTestResultPayload": {
            "success": [
                5
            ],
            "sent": [
                6
            ],
            "failed": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "FortuneSpinResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                238
            ],
            "__typename": [
                4
            ]
        },
        "FortuneSpinResultPayload": {
            "userPrize": [
                92
            ],
            "__typename": [
                4
            ]
        },
        "TelegramChatInput": {
            "CHAT_ID": [
                4
            ],
            "TELEGRAM_ID": [
                4
            ],
            "USER_ID": [
                6
            ],
            "PHONE": [
                4
            ],
            "STATUS": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "TelegramCreateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                94
            ],
            "__typename": [
                4
            ]
        },
        "TelegramUpdateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                94
            ],
            "__typename": [
                4
            ]
        },
        "TelegramAuthByPhoneResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                243
            ],
            "__typename": [
                4
            ]
        },
        "TelegramAuthByPhoneResultPayload": {
            "userId": [
                6
            ],
            "userName": [
                4
            ],
            "phone": [
                4
            ],
            "token": [
                4
            ],
            "chatId": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "ReviewServiceReviewResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                98
            ],
            "__typename": [
                4
            ]
        },
        "ReviewOrderGuestReviewResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                246
            ],
            "__typename": [
                4
            ]
        },
        "ReviewOrderGuestReviewResultPayload": {
            "redirectUrl": [
                4
            ],
            "departmentId": [
                6
            ],
            "departmentName": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderTestResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                248
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderTestResultPayload": {
            "num": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderPayOnlineResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                250
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderPayOnlineResultPayload": {
            "paymentUrl": [
                4
            ],
            "price": [
                6
            ],
            "order": [
                100
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderRepeatResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                100
            ],
            "__typename": [
                4
            ]
        },
        "SaleOrderCancelResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                100
            ],
            "__typename": [
                4
            ]
        },
        "VorderNewResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                254
            ],
            "__typename": [
                4
            ]
        },
        "VorderNewResultPayload": {
            "vorder": [
                255
            ],
            "__typename": [
                4
            ]
        },
        "Vorder": {
            "ID": [
                6
            ],
            "SESSION_ID": [
                4
            ],
            "FUSER_ID": [
                6
            ],
            "USER_ID": [
                6
            ],
            "USER": [
                43
            ],
            "ORDER_ID": [
                6
            ],
            "FIELDS_RAW": [
                7
            ],
            "PROPS_RAW": [
                7
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "ORDER": [
                100
            ],
            "PROFILE_ID": [
                6
            ],
            "DELIVERY_DEPARTMENT_ID": [
                6
            ],
            "PICKUP_DEPARTMENT_ID": [
                6
            ],
            "DEPARTMENT_ID": [
                6
            ],
            "BONUSES": [
                6
            ],
            "COUPONS": [
                120
            ],
            "BASKET": [
                165,
                {
                    "recalc": [
                        5
                    ]
                }
            ],
            "ATTR": [
                123
            ],
            "ATTRS": [
                130
            ],
            "__typename": [
                4
            ]
        },
        "VorderInput": {
            "attrs": [
                257
            ],
            "basket": [
                7
            ],
            "vorderId": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "OrderAttributesValueInput": {
            "DETAILS": [
                5
            ],
            "UUID": [
                4
            ],
            "FIO": [
                4
            ],
            "PHONE": [
                4
            ],
            "EMAIL": [
                4
            ],
            "DELIVERY_TYPE": [
                7
            ],
            "DELIVERY_DEPARTMENT": [
                6
            ],
            "STREET_PATH": [
                4
            ],
            "CITY": [
                4
            ],
            "CITY_FIAS_ID": [
                4
            ],
            "SETTLEMENT": [
                4
            ],
            "SETTLEMENT_FIAS_ID": [
                4
            ],
            "STREET_FIAS_ID": [
                4
            ],
            "STREET_COORDS": [
                229
            ],
            "HOUSE": [
                4
            ],
            "HOUSE_FIAS_ID": [
                4
            ],
            "HOUSE_COORDS": [
                229
            ],
            "FLAT": [
                4
            ],
            "LOCATION": [
                4
            ],
            "INTERCOM": [
                4
            ],
            "FLOOR": [
                4
            ],
            "ENTRANCE": [
                4
            ],
            "PRIVATE_HOUSE": [
                5
            ],
            "LIFT": [
                5
            ],
            "PICKUP_DEPARTMENT": [
                7
            ],
            "TIME_MODE": [
                124
            ],
            "DATE": [
                4
            ],
            "TIME": [
                7
            ],
            "PAYMENT_TYPE": [
                125
            ],
            "CASH_SUM": [
                6
            ],
            "BONUSES": [
                4
            ],
            "PROMOCODE": [
                4
            ],
            "DELIVERY_PRICE": [
                6
            ],
            "RECEIVER_NAME": [
                4
            ],
            "RECEIVER_ANOTHER": [
                5
            ],
            "RECEIVER_PHONE": [
                4
            ],
            "PERSONS_NUMBER": [
                6
            ],
            "COMMENT": [
                4
            ],
            "GIFTS_LIST": [
                4
            ],
            "WITH_OPERATOR": [
                5
            ],
            "ROISTAT": [
                4
            ],
            "NEED_CONFIRM": [
                5
            ],
            "PROFILE_COMMENT": [
                4
            ],
            "ADDRESS_SOURCE": [
                4
            ],
            "PROFILE_ID": [
                6
            ],
            "ADDRESS_IS_CUSTOM": [
                5
            ],
            "PROFILE_DEFAULT": [
                5
            ],
            "VORDER_ID": [
                6
            ],
            "SERVICE_SEND": [
                5
            ],
            "DATETIME": [
                6
            ],
            "SERVICE_SEND_START": [
                6
            ],
            "DATA": [
                258
            ],
            "RESERVE_SUCCESS_HASH": [
                4
            ],
            "DISCOUNT_REASON": [
                4
            ],
            "DISCOUNT_PERCENT": [
                6
            ],
            "ADDRESS": [
                4
            ],
            "BENEFIT_TYPE": [
                127
            ],
            "DELIVERY_FREE_FROM_PRICE": [
                4
            ],
            "STREET": [
                4
            ],
            "DEPARTMENT_SERVICE_ID": [
                6
            ],
            "DELIVERY_FREE_UPDATED_TIME": [
                6
            ],
            "IS_ACCEPTED": [
                5
            ],
            "TEST_TIME": [
                6
            ],
            "STRUCT": [
                4
            ],
            "TRANSPORT_TYPE": [
                128
            ],
            "COUPON_ID": [
                6
            ],
            "PRIZE_ID": [
                6
            ],
            "SESSION_ID": [
                4
            ],
            "PAYMENT_GIFT": [
                4
            ],
            "TEST_TIME_NEW": [
                6
            ],
            "APP_VERSION": [
                4
            ],
            "SOURCE": [
                4
            ],
            "RESERVE_REQUEST_TIME": [
                6
            ],
            "UTM_SOURCE": [
                4
            ],
            "RESERVE_AVAILABLE_TIME": [
                6
            ],
            "RESERVE_NEED_TIME": [
                6
            ],
            "RESERVE_STATUS": [
                4
            ],
            "RESERVE_SUCCESS_REQUEST_TIME": [
                6
            ],
            "UTM_MEDIUM": [
                4
            ],
            "UTM_CAMPAIGN": [
                4
            ],
            "UTM_TERM": [
                4
            ],
            "UTM_CONTENT": [
                4
            ],
            "UTM_LANDING_URL": [
                4
            ],
            "DELIVERY_ID": [
                6
            ],
            "PAY_SYSTEM_ID": [
                6
            ],
            "USER_DESCRIPTION": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "OrderDataInput": {
            "paramInt": [
                6
            ],
            "paramString": [
                4
            ],
            "paramArray": [
                7
            ],
            "__typename": [
                4
            ]
        },
        "VorderApplyResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                260
            ],
            "__typename": [
                4
            ]
        },
        "VorderApplyResultPayload": {
            "vorder": [
                255
            ],
            "__typename": [
                4
            ]
        },
        "VorderBasketResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                262
            ],
            "__typename": [
                4
            ]
        },
        "VorderBasketResultPayload": {
            "vorder": [
                255
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryCalculateInput": {
            "time": [
                6
            ],
            "mode": [
                264
            ],
            "__typename": [
                4
            ]
        },
        "TimeModeEnum": {},
        "VorderDeliveryCalculateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                266
            ],
            "__typename": [
                4
            ]
        },
        "VorderDeliveryCalculateResultPayload": {
            "vorder": [
                140
            ],
            "calc": [
                267
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryCalculate": {
            "ID": [
                6
            ],
            "VORDER_ID": [
                6
            ],
            "REQUEST_DELTA": [
                6
            ],
            "DELIVERY_HASH": [
                4
            ],
            "ORDER_ID": [
                39
            ],
            "DELIVERY_ADDRESS": [
                4
            ],
            "REQUEST_TIME_FORMATTED": [
                4
            ],
            "REQUEST_TIME": [
                6
            ],
            "NEED_TIME_FORMATTED": [
                4
            ],
            "NEED_TIME": [
                6
            ],
            "ORDER_PRICE": [
                6
            ],
            "RES_DELIVER_PRICE": [
                39
            ],
            "RES_TIME_FORMATTED": [
                4
            ],
            "RES_TIME": [
                6
            ],
            "RES_OFFICE_1C_ID": [
                6
            ],
            "RES_OFFICE_ID": [
                6
            ],
            "ADDRESS_COORDS": [
                4
            ],
            "PHONE": [
                4
            ],
            "RES_STATUS": [
                268
            ],
            "TRANSPORT_TYPE": [
                4
            ],
            "TIME_MODE": [
                264
            ],
            "__typename": [
                4
            ]
        },
        "DeliveryCalcStatusEnum": {},
        "VorderCouponResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                270
            ],
            "__typename": [
                4
            ]
        },
        "VorderCouponResultPayload": {
            "vorder": [
                140
            ],
            "coupon": [
                120
            ],
            "__typename": [
                4
            ]
        },
        "VorderSubmitResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                272
            ],
            "__typename": [
                4
            ]
        },
        "VorderSubmitResultPayload": {
            "vorder": [
                140
            ],
            "newVorderId": [
                6
            ],
            "orderId": [
                6
            ],
            "orderUrl": [
                4
            ],
            "order": [
                100
            ],
            "activeOrders": [
                100
            ],
            "__typename": [
                4
            ]
        },
        "VorderSyncResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                274
            ],
            "__typename": [
                4
            ]
        },
        "VorderSyncResultPayload": {
            "vorder": [
                255
            ],
            "__typename": [
                4
            ]
        },
        "SaleProfileDefaultResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                144
            ],
            "__typename": [
                4
            ]
        },
        "SaleProfileDeleteResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                6
            ],
            "__typename": [
                4
            ]
        },
        "SaleProfileSaveResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                144
            ],
            "__typename": [
                4
            ]
        },
        "SaleProfileCalcDeliveryResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                267
            ],
            "__typename": [
                4
            ]
        },
        "ElementInput": {
            "IBLOCK_ID": [
                6
            ],
            "NAME": [
                4
            ],
            "CODE": [
                4
            ],
            "__typename": [
                4
            ]
        },
        "SaleClientCardCreateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                172
            ],
            "__typename": [
                4
            ]
        },
        "SaleClientCardUpdateResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                172
            ],
            "__typename": [
                4
            ]
        },
        "CallTrackingRequestPhoneResult": {
            "success": [
                5
            ],
            "errors": [
                1
            ],
            "error": [
                1
            ],
            "state": [
                155
            ],
            "payload": [
                283
            ],
            "__typename": [
                4
            ]
        },
        "CallTrackingRequestPhoneResultPayload": {
            "phone": [
                205
            ],
            "__typename": [
                4
            ]
        }
    }
}